/* Edit case */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaTimes } from "react-icons/fa";
import "../components/CaseSelector/CaseEntries/CaseEntries.css";
import Modal from "react-responsive-modal";
import { requestPageOfAceAlert } from "../components/Admin/storeAceAlerts/action";
import axios from "axios";
import { apiUri } from "../config";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import {
	//padCalendar,
	//numberWithCommas,
	allowAlphaNumeric,
	onlyNumeric,
	//formatDateAdded,
	isAdmin/*,
	isDandoEnabled*/
} from "../util";
// import DisclosureModal from "./components/DisclosureModal";

import Select from 'react-select';
import TableGrid from "../common/components/TableGrid/tableGrid";
import { aceAlertsEntriesColumns } from "../common/components/TableGrid/tableColumn/AceAlertsEntriesColumns";

const state = {
	className: "CaseSelectorEntry"
};

const integerRegrex = /^[0-9]*$/;
const aphabetnumberRegex = /^[a-zA-Z0-9]*$/;

class AceAlertsEntries extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			dandoDataArray: [],
			currentAceAlert: [],
			sortValue: "",
			sortOrder: "",
			aceAlertData: {},
			className: "CaseSelectorEntry",
			isAdminToken: isAdmin(),
			open: false,
			fileUploadOpen: false,
			heading: "Update Risk",
			EditAceAlertData: {},
			EditAceAlertFile: {},
			openDelete: false,
			viewerModal: false,
			deleteModalData: {},
			companyNameError: "",
			riskAssessmentDateError: "",
			tickerError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			caseFileError: "",
			notesError:"",
			indexListIdError:"",
			identifierError: "",
			fileUploadError: "",
			enableView: false,
			enableCMView: false,
			enableAlert: false,
			indexList: [],
			alertInfo: false,
		};
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleSaveAlert = this.handleSaveAlert.bind(this);
	}


	goToCases = (alertId)=> {
		this.props.history.push("/cases/" + alertId);
	}
	handleSaveAlert(data) {
		let status = true;
		if (
			!this.state.EditAceAlertData.companyName ||
			this.state.EditAceAlertData.companyName.trim() === ""
		) {
			status = false;
			this.setState({
				companyNameError: "Company Name required!"
			});
		} else {
			this.setState({ companyNameError: "" });
		}

		if (
			!this.state.EditAceAlertData.riskAssessmentDate ||
			this.state.EditAceAlertData.riskAssessmentDate === ""
		) {
			status = false;
			this.setState({
				riskAssessmentDateError: "Risk Assessment Date required!"
			});
		} else {
			this.setState({ riskAssessmentDateError: "" });
		}

		if (
			!this.state.EditAceAlertData.ticker ||
			this.state.EditAceAlertData.ticker.trim() === ""
		) {
			status = false;
			this.setState({
				tickerError: "Ticker required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditAceAlertData.ticker)) {
				status = false;
				this.setState({
					tickerError: "Enter only alphanumeric characters"
				});
			} else {
			this.setState({ tickerError: "" });
			}
		}

		if (
			!this.state.EditAceAlertData.identifier ||
			this.state.EditAceAlertData.identifier.trim() === ""
		) {
			status = false;
			this.setState({
				identifierError: "Identifier required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditAceAlertData.identifier)) {
				status = false;
				this.setState({
					identifierError: "Enter only alphanumeric characters"
				});
			} else {
				this.setState({ identifierError: "" });
			}
		}

		if (
			!this.state.EditAceAlertData.sicCode ||
			this.state.EditAceAlertData.sicCode === ""
		) {
			status = false;
			this.setState({
				sicCodeError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditAceAlertData.sicCode)) {
				status = false;
				this.setState({
					sicCodeError: "Enter only numbers"
				});
			} else {
			this.setState({ sicCodeError: "" });
			}
		}

		if (
			!this.state.EditAceAlertData.cik ||
			this.state.EditAceAlertData.cik === ""
		) {
			status = false;
			this.setState({
				cikError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditAceAlertData.cik)) {
				status = false;
				this.setState({
					cikError: "Enter only numbers"
				});
			} else {
			this.setState({ cikError: "" });
			}
		}

		if (
			!this.state.enableDandO &&
			(!this.state.EditAceAlertData.market ||
			this.state.EditAceAlertData.market.trim() === "")
		) {
			status = false;
			this.setState({
				marketError: "Market required!"
			});
		} else {
			this.setState({ marketError: "" });
		}

		if (
			!this.state.enableDandO &&
			(!this.state.EditAceAlertData.caseFile ||
			this.state.EditAceAlertData.caseFile.trim() === "")
		) {
			status = false;
			this.setState({
				caseFileError: "Case File required!"
			});
		} else {
			this.setState({ caseFileError: "" });
		}

		if (
			!this.state.EditAceAlertData.indexListId ||
			isNaN(this.state.EditAceAlertData.indexListId)
		) {
			status = false;
			this.setState({
				indexListIdError: "Must Select an industry index!"
			});
		} else {
			this.setState({ indexListIdError: "" });
		}
		
		if (status) {
			this.props.handleSaveFileData(data);
			this.setState({ open: false });
			if (this.state.enableDandO) {
				this.props.requestPageOfAceAlert(
					this.props.currentPage,
					this.state.sortValue,
					this.state.sortOrder
				);
			} 
		} else {
			return false;
		}
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.aceAlerts) {
			if (this.state.isAdminToken && this.state.routeName === "/ACEAlerts") {
				this.setState({ enableView: true });
			}
			nextProps.aceAlerts.forEach(element => {
				element.enableEdit = false;
				element.riskAssessmentDate_UI = element.riskAssessmentDate;
			});
			this.setState({ dandoDataArray: nextProps.aceAlerts });
			if (this.state.routeName === "/AceAlertsManagement") {
				this.setState({ enableDandO: true });
			}
			
		}
	};

	componentWillMount() {
		let state = this.state;
		state.dandoDataArray = this.props.aceAlerts;

		state.dandoDataArray.forEach(element => {
			element.enableEdit = false;
			element.riskAssessmentDate_UI = element.riskAssessmentDate;
		});
		state.routeName = window.location.pathname;
		this.setState(state);
		this.setState({ dandoDataArray: state.dandoDataArray });
	};

	componentDidMount() {
		if (this.state.routeName === "/AceAlertsManagement") {
			this.setState({ enableDandO: true });
			this.getIndexList();
		}
	};

	handleDelete = dando => {
		let url = "";
		if (this.state.enableDandO) {
			url = "/alert/"+dando.alertId;
		} 
		axios
			.delete(apiUri+url)
			.then(json => {
			if (json.data && json.data.statusCode === 204) {
				if (this.state.enableDandO) {
					this.props.requestPageOfAceAlert(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
				} 
				NotificationManager.success(json.data.statusMessage, "Success");
				this.setState({ openDelete: false, deleteModalData: {} });
			}
			})
			.catch(err => {
			NotificationManager.error(err);
			console.log(err);
			});
	};

	handleOnChange = (DandOData, value, key) => {
		let state = this.state;
		if (key === "enabled") {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			if (value === "false") {
				state.EditAceAlertData["enabled"] = true;
			} else {
				state.EditAceAlertData["enabled"] = false;
			}
		} else if (key === "riskAssessmentDate" ) {
			this.setState({ [key]: value, [key + "Error"]: "" });
			let d = value;
			//d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
			state.EditAceAlertData[key] = new Date(value).getTime();
			state.EditAceAlertData[key + "_UI"] =
			new Date(d).getFullYear() +
			"-" +
			("0" + (new Date(d).getMonth() + 1)).slice(-2) +
			"-" +
			("0" + new Date(d).getDate()).slice(-2);
		} else {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			state.EditAceAlertData[key] = value;
		}
		this.setState({ EditAceAlertData: state.EditAceAlertData });
		if (state.enableDandO) {
			
			
		} else {
			this.props.requestPageOfAceAlert(
				this.props.currentPage,
				this.state.sortValue,
				this.state.sortOrder
			);
		}
		
	};

	handleDandOStatusOnChange = (DandOData, value, key) => {
		let state = this.state;
		this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
		state.EditAceAlertFile[key] = value;
		this.setState({ EditAceAlertFile: state.EditAceAlertFile });
		
	};

	handleEnable = (DandOData, value, key) => {
		let state = this.state;
		state.dandoDataArray.forEach(element => {
			if (state.enableDandO) {
				if (element.alertId === DandOData.alertId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			} else {
				if (element.alertId === DandOData.alertId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			}
		});
		this.setState({...state})
	};

	componentDidCatch(error, errorInfo) {
		console.log("Error:", error, errorInfo);
	}

	handleEdit = (DandOData, value) => {

		let state = this.state;
		state.dandoDataArray.forEach(element => {
			if (state.enableDandO) {
				if (element.id === DandOData.id) {
					element.enableEdit = true;
					element.riskAssessmentDate =
						new Date(element.riskAssessmentDate_UI).getTime() +
						new Date(element.riskAssessmentDate_UI).getTimezoneOffset() *
						60 *
						1000;
				}
			} else {
				if (element.alertId === DandOData.alertId) {
					element.enableEdit = true;
					element.riskAssessmentDate =
						new Date(element.riskAssessmentDate_UI).getTime() +
						new Date(element.riskAssessmentDate_UI).getTimezoneOffset() *
						60 *
						1000;
				}
			}
		});
		this.setState(state);
		this.setState({ EditAceAlertData: DandOData, open: true });
		
	};

	onOpenModal = () => {
		this.setState({ open: true });
	};

	onCloseModal = () => {
		this.setState({ open: false, openDelete: false });
		this.resetErrorStat();
	};

	onCloseUploadModal = () => {
		this.setState({ open: false, fileUploadOpen: false });
		this.resetErrorStat();
	};

	onCloseViewerModal = () => {
		this.setState({ open: false, viewerModal: false });
		this.resetErrorStat();
	};

	onCloseDandOInfoModal = () => {
		this.setState({ DandOInfo: false });
	};

	resetErrorStat = () => {
		this.setState({
			companyNameError: "",
			riskAssessmentDateError: "",
			tickerError: "",
			docketIdError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			caseFileError: "",
			notesError:"",
			indexListIdError:"",
			identifierError: ""
		});
	};

	handleChange = name => event => {
		this.setState({ ...state, [name]: event.target.checked });
	};

	handleSelectChange = (selectedOption) => {
		let state = this.state;
		this.setState({ "indexListId": selectedOption.value, "indexListIdError": "" });
		state.EditAceAlertData["indexListId"] = selectedOption.value;
	//var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(selectedOption.value);

	};

	handleInfo = (selectedDando) => {

		this.setState({
			DandOInfo: true
		});
		this.setState({ "currentDandO": selectedDando});

	};

	setSelectDefault = (inValue) => {
		var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(inValue);
		return getIndex;
	};

	getIndexList() {
		axios
			.get(apiUri + "/cases/getIndexList")
			.then(res => {
				this.setState({
					indexList: res.data['content']
				});

			})
			.catch(err => {
				console.log(err);
			});

	};

	getamendClaimsList() {
		axios
			.get(apiUri + "/cases/amendClaims")
			.then(res => {
				this.setState({ amendClaimsList: res.data.content });
			})
			.catch(err => {
				console.log(err);
			});
	};

	getDandOInfoById(id) {
		this.setState({
			DandOInfo: true
		});
		let myResponse = this.props.getDandOInfoById(id);

		this.setState({currentDandO : myResponse})
	};

	 

	handleTrash = (filledCase) => this.setState({
		openDelete: true,
		deleteModalData: filledCase
	})

	render() {
		let props = this.props;
		let state = this.state;
		const { routeName, className, enableDandO, enableView } = this.state;
		const { firmSettings = {} } = this.props;

		const columns = aceAlertsEntriesColumns({
			routeName,
			className,
			enableDandO,
			enableView,
			firmSettings,
			goToCases:this.goToCases,
			handleEnable: this.handleEnable,
			handleEdit: this.handleEdit,
			handleTrash: this.handleTrash,
			handleInfo: this.handleInfo,
			handleViewer: this.handleViewer
		});

		return (
			<React.Fragment>
				<Modal open={this.state.open} onClose={this.onCloseModal}>
					<div className="ModalWindow modaladd">
					<FaTimes className="closeicon" onClick={this.onCloseModal} />
					<h3 className="modalHeading">{state.heading}</h3>
					<div className="NavDivider"></div>
					<table>
						<thead></thead>
						<tbody>
						<tr>
							<td className="modalTd">
							Risk Name:
							</td>
							<td style={{ paddingTop: 16 }}>
							<input
								id="search"
								type="text"
								className="searchBox2"
								value={state.EditAceAlertData.companyName || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"companyName"
								);
								}}
							/>
							<span id="error-style">{this.state.companyNameError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Risk Assessment Date</td>
							<td style={{ paddingTop: 16 }}>
							<DatePicker
								className="searchBox2"
								selected={state.EditAceAlertData.riskAssessmentDate || ""}
								onChange={evt =>
								this.handleOnChange(
									state.EditAceAlertData,
									evt,
									"riskAssessmentDate"
								)
								}
								dateFormat="yyyy-MM-dd"
							/>
							<span id="error-style">
								{this.state.riskAssessmentDateError}
							</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Ticker</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => allowAlphaNumeric($event)}
								value={state.EditAceAlertData.ticker || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"ticker"
								);
								}}
							/>
							<span id="error-style">{this.state.tickerError}</span>
							</td>
						</tr>
						 <tr>
						 <td className="modalTd">CapIQ Identifier</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => allowAlphaNumeric($event)}
								value={state.EditAceAlertData.identifier || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"identifier"
								);
								}}
							/>
							<span id="error-style">{this.state.identifierError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">SIC Code</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => onlyNumeric($event)}
								value={state.EditAceAlertData.sicCode || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"sicCode"
								);
								}}
							/>
							<span id="error-style">{this.state.sicCodeError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">CIK Code</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => onlyNumeric($event)}
								value={state.EditAceAlertData.cik || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"cik"
								);
								}}
							/>
							<span id="error-style">{this.state.cikError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Market</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditAceAlertData.market || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"market"
								);
								}}
							/>
							<span id="error-style">{this.state.marketError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Case File</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditAceAlertData.caseFile || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"caseFile"
								);
								}}
							/>
							<span id="error-style">{this.state.caseFileError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Notes:</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditAceAlertData.notes || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"notes"
								);
								}}
							/>
							<span id="error-style">{this.state.notesError}</span>
							</td>
						</tr>
						{state.enableDandO ? (
							<tr>
							<td className="modalTd">Status</td>
							<td
								style={{ paddingTop: 16, zIndex: 1 }}
								className="relativePos"
							>
								<select
								style={{ width: "100%" }}
								className="statusSelect"
								value={state.EditAceAlertData.status || ""}
								onChange={evt => {
									this.handleOnChange(
									state.EditAceAlertData,
									evt.target.value,
									"status"
									);
								}}
								>
								<option value="SUBMITTED">SUBMITTED</option>
								<option value="REJECTED">REJECTED</option>
								<option value="PROCESSING">PROCESSING</option>
								<option value="COMPLETED">COMPLETED</option>
								</select>
							</td>
							</tr>
						) : null}
						
						<tr>
							<td className="modalTd">Industry Index </td>
							<td
							style={{ paddingTop: 16, zIndex: 1, width: "60%", color: "black"  }}
							className="relativePos"
							>
							<Select
								style={{ width: "100%", zIndex: 100, color: "black"  }}
								width="100%"
								name="indexListId"
								defaultValue={state.indexList[this.setSelectDefault(state.EditAceAlertData.indexListId)]}
								onChange={this.handleSelectChange}
								options={state.indexList}

							/> 
							 <span id="error-style">{this.state.indexListIdError}</span>
							</td>
						</tr>
						</tbody>
					</table>
					<div className="btnHolder">
						<br />
						<button
						className="btn btnS"
						onClick={evt => {
							this.handleSaveAlert(state.EditAceAlertData);
						}}
						>
						Save
						</button>
						&nbsp; &nbsp;
						<button
						className="btn btnC"
						onClick={evt => {
							this.setState({ open: false, EditAceAlertData: {} });
							this.resetErrorStat();
						}}
						>
						Cancel
						</button>
					</div>
					</div>
				</Modal>
				<Modal
					open={this.state.openDelete}
					onClose={this.onCloseModal}
					className="deltemodal"
				>
					<div>
					<FaTimes className="deleteicon" onClick={this.onCloseModal} />
					</div>
					<div className="ModalWindow ModalDelete">
					<p style={{ textAlign: "center" }}>
						Are you sure you want to delete 
						 {" "+state.deleteModalData.companyName}?
					</p>
					<div className="textCenter">
						<button
						className="btn btnS"
						onClick={evt => {
							this.handleDelete(state.deleteModalData);
						}}
						>
						Delete
						</button>
						&nbsp; &nbsp;
						<button
						className="btn btnC"
						onClick={evt => {
							this.setState({ openDelete: false, deleteModalData: {} });
						}}
						>
						Cancel
						</button>
					</div>
					</div>
				</Modal>

				<TableGrid
					columns = {columns}
					data = {state.dandoDataArray}
					handleSort = {props.handleSorting}
					sortValue = {props.sortValue}
					sortOrder = {props.sortOrder}
				/>

			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentAceAlert: state.aceAlerts.currentAceAlert,
		currentPage: state.aceAlerts.currentPage,
		totalAceAlert: state.aceAlerts.totalAceAlert,
		totalPages: state.aceAlerts.totalPages,
		firmSettings: state.firmSettings,
		alertInfo: state.aceAlerts.alertInfo
	};
};
const mapDispatchToProps = dispatch => {
	return {
		requestPageOfAceAlert: (page, sortValue, sortOrder) =>
			dispatch(requestPageOfAceAlert(page, sortValue, sortOrder))
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(AceAlertsEntries));



// WEBPACK FOOTER //
// ./src/ace/AceAlertsEntries.js